import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomMUIButton } from '../../commons/buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../models/Common';

interface SavePaymentCardProps {
  handlePay: (cardId?: number, saveCard?: boolean | number) => void;
  step: number;
}

export const SavePaymentCard: FC<SavePaymentCardProps> = ({ handlePay, step }) => {
  const { t } = useTranslation();

  return (
    <div className={`payment__type__container__content__save-card ${step !== 0 ? 'slideIn' : ''}`}>
      <div className="payment__type__container__content__save-card__info">
        <h3>{t('servicePayment.saveCard')}</h3>
        <p>{t('servicePayment.autofillCardData')}</p>
      </div>
      <div className="payment__type__container__content__save-card__btns">
        <CustomMUIButton
          label={t('buttons.save')}
          className={ButtonClassNames.PrimaryFulfilled}
          handleClick={() => handlePay(undefined, 1)}
          isBold
        />
        <CustomMUIButton
          label={t('buttons.later')}
          className={ButtonClassNames.SecondaryOutlined}
          handleClick={() => handlePay(undefined, 0)}
          isBold
        />
      </div>
    </div>
  );
};
